import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginForm from "../../../components/login/LoginForm";
import LeftSection from "../../../components/login/LeftSection";
import Loading from "../../../components/common/Loading";
import { google } from "../../../assets";
import { useSelector } from "react-redux";
import {
  getAccessToken,
  getError,
  getGoogleLoginStatus,
  getStatus,
  removeLoginMessage,
} from "../../../redux/slice/userSlice";
import AlertBox from "../../../components/common/AlertBox";
import { FaAngleLeft } from "react-icons/fa";
import { BASE_URL } from "../../../api/apiIndex";
import LogoContainer from "../../../components/home/header/LogoContainer";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const status = useSelector(getStatus);
  const error = useSelector(getError);

  const googleStatus = useSelector(getGoogleLoginStatus);

  const token = useSelector(getAccessToken);

  useEffect(() => {
    if (status === "success" || token) {
      navigate("/client/home", { replace: true });
    }
  }, [navigate, status, token]);

  const handleGoogleLogin = () => {
    window.open(`${BASE_URL}/auth/google`, "_self");
  };

  return (
    <div className="flex justify-center items-start">
      <LeftSection />

      {/* Right Section */}
      {status === "loading" || googleStatus === "loading" ? <Loading /> : null}
      {status === "failed" ? (
        <AlertBox
          type={status}
          message={error}
          toDispatch={removeLoginMessage}
        />
      ) : null}

      {location?.state?.message ? (
        <AlertBox type="success" message={location?.state?.message} />
      ) : null}

      <section className="flex-1 flex flex-col md:py-8 py-5 items-center">
        <div className="flex justify-between sm:px-12 px-0 w-full">
          <div className="w-full flex justify-between items-center">
            <Link
              className="flex justify-center items-center max-w-[100px]"
              to="/"
            >
              <FaAngleLeft className="text-textPrimary" />
              <span className="text-textPrimary font-semibold pl-1">Back</span>
            </Link>
            <LogoContainer />
          </div>
        </div>
        <div className="py-6">
          <div className="flex flex-col sm:w-[425px] w-[270px]">
            <h1 className="text-textPrimary font-bold sm:text-[30px] text-[26px] leading-[45px]">
              Login to Intrance
            </h1>
            <p className="text-textSecondary text-[16px] mb-[30px]">
              With your registered Email Address
            </p>

            <LoginForm />

            {/* Register Now section */}
            <p className="self-center pt-6 text-textSecondary">
              New to Intrance?&nbsp;
              <Link
                to="/register"
                className="text-secondary font-medium border-b-2 border-secondary italic"
              >
                Register here !
              </Link>
            </p>

            <span className="mt-6 text-center">Or</span>

            <button
              onClick={handleGoogleLogin}
              className="mt-3 flex justify-center gap-4 items-center login-input outline outline-[1px] outline-textSecondary/60"
            >
              <img
                src={google}
                alt="google logo"
                className="h-[24px] w-[24px]"
              />
              <span className="self-center font-medium text-xl">
                Login with Google
              </span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
